const RateState = {
  rates: {}
};

export default RateState;
